import { Box, Modal } from "@mui/material";
import { ReactNode } from "react";
import { Close } from "@mui/icons-material";

interface IProps {
  isOpen: boolean;
  setIsOpen?: (isOpen: boolean) => void;
  children: ReactNode;
}

export function ModalConfiguracoes({ isOpen, children, setIsOpen }: IProps) {
  return (
    <Modal
      open={isOpen}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          height: "auto",
          width: "100%",
          maxWidth: 850,
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: "1rem",
          border: "none",
          outline: "none",
          padding: "24px",
        }}
      >
        <div style={{"display":"flex","justifyContent":"space-between","alignItems":"center"}}>
          <h6 style={{"padding":"0","margin":"0","fontSize":"1.25rem","lineHeight":"1.75rem","fontWeight":600}}>Configurações de campanhas</h6>
          <Close
            style={{"cursor":"pointer"}}
            onClick={setIsOpen ? () => setIsOpen(false) : undefined}
          />
        </div>
        {children}
      </Box>
    </Modal>
  );
}
